/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Message_PlaceholderInputs */

const en_contact_form_message_placeholder = /** @type {(inputs: Contact_Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us about your business and what you need. For a problem: what happened, and the steps to see it.`)
};

const pl_contact_form_message_placeholder = /** @type {(inputs: Contact_Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opowiedz o swojej działalności i czego potrzebujesz. Przy problemie: co się stało i jak to powtórzyć.`)
};

/**
* | output |
* | --- |
* | "Tell us about your business and what you need. For a problem: what happened, and the steps to see it." |
*
* @param {Contact_Form_Message_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_message_placeholder = /** @type {((inputs?: Contact_Form_Message_PlaceholderInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Message_PlaceholderInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_message_placeholder(inputs)
	return en_contact_form_message_placeholder(inputs)
});